/**
 * Created by Jerker Nord on 2020-01-09.
 */
import {
    ITextBetLineNumberConfig,
    TextBetLineNumber
} from "@nolimitcity/slot-game/bin/game/betline/number/TextBetLineNumber";
import {isNumber} from "util";

export class BonusBunniesBetlineNumber extends TextBetLineNumber{

    constructor(index: number, config: ITextBetLineNumberConfig) {
        super(index, config);
    }

    protected draw(config:ITextBetLineNumberConfig):void {
        //Do nothing
    }

    protected showNormal():void {
        //Do nothing
    }

    protected showWin(): void {
        //Do nothing
    }
}